import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { catchError, Observable, retry, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { TramiteEmvs } from '../listado/listado-tramites-emvs/tramite-emvs';
import { AutorizacionFirmaEstado } from '../listado/listado-tramites-emvs/autorizacion-firma-estado.model';
import { AutorizacionEmvs } from '../model/autorizacionEmvs';
import { CircunstanciasEmvs } from '../model/circunstanciasEmvs';
import { ConsultaEmvs } from '../model/consultaEmvs';
import { DatosPersonalesEmvs } from '../model/datospersonalesEmvs';
import { DatosRepresentanteEmvs } from '../model/datosrepresentanteEmvs';
import { DenominacionPuesto } from '../model/denominacionpuesto';
import { DistritosEmvs } from '../model/distritosEmvs';
import { InstanciaGeneral } from '../model/instanciageneral';
import { OrdenConvocatoria } from '../model/ordenconvocatoria';
import { PuestoEmvs } from '../model/puestoEmvs';
import { UnidadFamiliarEmvs } from '../model/unidadfamiliarEmvs';
import { VulnerabilidadEmvs } from '../model/vulnerabilidadEmvs';

@Injectable({
  providedIn: 'root'
})

export class SolicitudEmvsService {


  API_URL: string = environment.API_URL;

  constructor(
    private http: HttpClient
  ) { }

  saveTramite(form: FormGroup): Observable<any> {
    let API_URL = `${this.API_URL}/tramite_emvs/save`;
    return this.http.post(API_URL, form)
  }

  saveTramiteWithoutData(form: FormGroup): Observable<any> {
    let API_URL = `${this.API_URL}/tramite_emvs/save`;
    return this.http.post(API_URL, form)
  }

  saveCircunstanciasEmvs(data: CircunstanciasEmvs): Observable<any> {
    let API_URL = `${this.API_URL}/circunstancia_economicas_rpsv/save`;
    return this.http.post(API_URL, data)
  }

  saveUnidadFamiliar(data: UnidadFamiliarEmvs): Observable<any> {
    let API_URL = `${this.API_URL}/unidad_familiar_emvs/save`;
    return this.http.post(API_URL, data)
  }

  saveDistritos(data: DistritosEmvs): Observable<any> {
    let API_URL = `${this.API_URL}/distritos_municipales_emvs/save`;
    return this.http.post(API_URL, data)
  }

  saveVulnerabilidad(data: VulnerabilidadEmvs): Observable<any> {
    let API_URL = `${this.API_URL}/anexo1_emvs/save`;
    return this.http.post(API_URL, data)
  }

  saveAutorizacion(data: AutorizacionEmvs): Observable<any> {
    let API_URL = `${this.API_URL}/autorizacion_consulta_datos/save`;
    return this.http.post(API_URL, data)
  }

  saveConsulta(data: ConsultaEmvs): Observable<any> {
    let API_URL = `${this.API_URL}/consulta_datos_solicitante/save`;
    return this.http.post(API_URL, data)
  }

  saveRepresentado(data: DatosRepresentanteEmvs): Observable<any> {
    let API_URL = `${this.API_URL}/datos_representante/save`;
    return this.http.post(API_URL, data)
  }

  getRepresentadoByIdTramite(idTramite: string) {
    let API_URL = `${this.API_URL}/datos_representante/getByIdTramite/${idTramite}`;
    return this.http.get(API_URL, { observe: 'response' })
  }

  getInstanciaByIdTramite(idTramite: string) {
    let API_URL = `${this.API_URL}/instancia_general/getByIdTramite/${idTramite}`;
    return this.http.get(API_URL, { observe: 'response' })
  }

  getCircustanciasByIdTramite(idTramite: string) {
    let API_URL = `${this.API_URL}/circunstancia_economicas_rpsv/getByIdTramite/${idTramite}`;
    return this.http.get(API_URL, { observe: 'response' })
  }

  getPuestosByIdTramite(idTramite: string) {
    let API_URL = `${this.API_URL}/puestos/get/${idTramite}`;
    return this.http.get(API_URL, { observe: 'response' })
  }

  getUnidadByIdTramite(idTramite: string) {
    let API_URL = `${this.API_URL}/unidad_familiar_emvs/getByIdTramite/${idTramite}`;
    return this.http.get(API_URL, { observe: 'response' })
  }
  getDistritoByIdTramite(idTramite: string) {
    let API_URL = `${this.API_URL}/distritos_municipales_emvs/getByIdTramite/${idTramite}`;
    return this.http.get(API_URL, { observe: 'response' })
  }
  getVulnerableByIdTramite(idTramite: string) {
    let API_URL = `${this.API_URL}/anexo1_emvs/getByIdTramite/${idTramite}`;
    return this.http.get(API_URL, { observe: 'response' })
  }
  getAutorizacionByIdTramite(idTramite: string) {
    let API_URL = `${this.API_URL}/autorizacion_consulta_datos/getByIdTramite/${idTramite}`;
    return this.http.get(API_URL, { observe: 'response' })
  }

  getEstadoFirmaAutorizadosByTramite(idTramite: string) {
    const API_URL = `${this.API_URL}/autorizacion_consulta_datos/estadoFirmaByTramite/${idTramite}`;
    return this.http.get<AutorizacionFirmaEstado[]>(API_URL, { observe: 'response' });
  }

  savePuesto(data: PuestoEmvs): Observable<any> {
    let API_URL = `${this.API_URL}/puestos/save`;
    return this.http.post(API_URL, data)
  }

  saveDatosPersonales(data: DatosPersonalesEmvs): Observable<any> {
    let API_URL = `${this.API_URL}/datos_personales/save`;
    return this.http.post(API_URL, data)
  }

  saveFilePuestos(form: FormData): Observable<any> {
    let API_URL = `${this.API_URL}/puestos/saveFile`;
    return this.http.post(API_URL, form)
  }

  saveFicheros(data: any[]): Observable<any> {
    let API_URL = `${this.API_URL}/ficheros_emvs/save`;
    return this.http.post(API_URL, data)
  }

  saveInstancia(data: InstanciaGeneral): Observable<any> {
    let API_URL = `${this.API_URL}/instancia_general/save`;
    return this.http.post(API_URL, data)
  }

  getPoliticas(id: number): Observable<any> {
    let API_URL = `${this.API_URL}/politicas/get/${id}`;
    return this.http.get(API_URL)
  }

  savePdf(pdf, idTramite): Observable<any> {
    let API_URL = `${this.API_URL}/tramite_emvs/savePdf`;
    return this.http.post(API_URL, { pdf, idTramite });
  }

  saveDocumentosAdjuntos(data: any[]): Observable<any> {

    let API_URL = `${this.API_URL}/documentos_adjuntos/save`;
    return this.http.post(API_URL, data);
  }

  getOrdenConvocatoria(): Observable<OrdenConvocatoria> {
    return this.http
      .get<OrdenConvocatoria>(`${this.API_URL}/orden_convocatoria/list`)
      .pipe(retry(1), catchError(this.handleError));
  }

  getDenominacionPuesto(): Observable<DenominacionPuesto> {
    return this.http
      .get<DenominacionPuesto>(`${this.API_URL}/denominacion_puesto/list`)
      .pipe(retry(1), catchError(this.handleError));
  }


  updateEstadoTramite(tramite: TramiteEmvs) {
    tramite.usuario_id = null
    return this.http.post<TramiteEmvs>(`${this.API_URL}/tramite_emvs/updateEstado`, tramite);
  }
  updateEstadoTramiteById(idTramite: any) {
    return this.http.post<TramiteEmvs>(`${this.API_URL}/tramite_emvs/updateEstadoFinalIdTramite/${idTramite}`,'');
  }
  updateLastVisitedTab(tramite: Partial<TramiteEmvs>) {
    tramite.procedimiento_id = null
    tramite.usuario_id = null
    return this.http.post<TramiteEmvs>(`${this.API_URL}/tramite_emvs/updateLastVisitedTab`, tramite);
  }

  updateTramite(tramite: Partial<TramiteEmvs>) {
    tramite.procedimiento_id = null
    tramite.usuario_id = null
    return this.http.post<TramiteEmvs>(`${this.API_URL}/tramite_emvs/updateLastVisitedTab`, tramite);
  }

  deleteFamiliarById(id: number) {
    return this.http.delete<void>(`${this.API_URL}/unidad_familiar_emvs/${id}`);
  }

  deleteAutorizacionById(id: any) {
    return this.http.delete<void>(`${this.API_URL}/autorizacion_consulta_datos/${id}`);
  }
  
  getByIdNexcloud(idNexcloud: string) {
    let API_URL = `${this.API_URL}/documentoeni/getByIdNexcloud/${idNexcloud}`;
    return this.http.get(API_URL);
  }

  getDocAdjuntosByIdTramite(idTramite: string) {
    let API_URL = `${this.API_URL}/documentos_adjuntos/getByIdTramite/${idTramite}`;
    return this.http.get(API_URL);
  }

  handleError(error: any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = error.error.message;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(() => {
      return errorMessage;
    });
  }
  getFicheros(id: any): Observable<any> {
    let API_URL = `${this.API_URL}/ficheros_emvs/get/${id}`;
    return this.http.get(API_URL)
  }
}
